<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="供应商名称" prop="customerName">
        <el-input v-model.trim="queryParams.customerName" placeholder="请输入供应商名称" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="手机号" prop="phoneNumber">
        <el-input v-model.trim="queryParams.phoneNumber" placeholder="请输入手机号" clearable maxlength="11"
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="邮箱号" prop="email">
        <autocompelete-email v-model.trim="queryParams.email" @keyup.enter.native="handleQuery" clearable placeholder="请输入邮箱" @complete="handleQuery"></autocompelete-email>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="状态" prop="status">
        <el-select-dict dictType="STATUS" clearable placeholder="请选择状态" v-model="queryParams.status"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['finance:supplier:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['finance:supplier:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['finance:supplier:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="customerTable" :class="{ empty: list.length === 0 }" empty-text=" "  v-loading="loading" :data="list"
          row-key="customerId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55" align="center" />
          <el-table-column label="供应商名称" prop="customerName" align="center" min-width="128px" show-overflow-tooltip  />
          <el-table-column-dict dictType="SEX" label="性别" prop="sex" align="center" min-width="80px" />
          <el-table-column-dict maskType="mobile" label="手机号" prop="phoneNumber" align="center" min-width="120px" />
          <el-table-column-dict :maskStart="3" :maskMiddle="4" :maskEnd="8" label="邮箱" prop="email" align="center" min-width="188px" />
          <el-table-column-dict dictType="STATUS" dictTypeNode="tag" label="状态" align="center" prop="status"
            min-width="100px"></el-table-column-dict>
          <el-table-column label="操作人" show-overflow-tooltip align="center" min-width="168px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建人：</span>
                    <span class="value">{{ scope.row.creator?.userName || "--" }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新人：</span>
                    <span class="value">{{ scope.row.updater?.userName || "--" }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建时间：</span>
                    <span class="value">{{ scope.row.createTime | formatDate("datetime", "--") }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新时间：</span>
                    <span class="value">{{ scope.row.updateTime | formatDate("datetime", "--") }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="
            mixinHasPermi([
              'finance:supplier:status',
              'finance:supplier:read',
              'finance:supplier:delete',
            ])
          " label="操作" align="center" :width="288 + 'px'" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['finance:supplier:status']" :disabled="scope.row.beUsedInInventoryRecord || scope.row.customerId == 1" size="mini"
                :type="scope.row.status === '1' ? 'warning' : 'success'"
                @click.native.stop="handleStatusChange(scope.row)">{{ scope.row.status === "1" ? "停用" : "启用"
                }}</el-button>
              <el-button v-hasPermission="['finance:supplier:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button v-hasPermission="['finance:supplier:delete']" :disabled="scope.row.beUsedInInventoryRecord || scope.row.customerId == 1" size="mini"
                type="danger" icon="el-icon-delete" @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <!-- 添加或编辑对话框 -->
    <customer-dialog ref="customerDialog" :visible.sync="open" :modal-append-to-body="false" :close-on-click-modal="false"
      :isUpdate="isUpdate" :baseForm="baseForm" @close="open = false" @successs="getList" width="1024px"></customer-dialog>
  </div>
</template>

<script>
import { customerApi } from "@/api"
import customerDialog from "./components/supplier-dialog.vue"
import AutocompeleteEmail from "@/components/autocomplete-email/index.vue"
export default {
  name: "financeCustomerManage",
  components: {
    customerDialog,
    AutocompeleteEmail
  },
  data() {
    return {
      showImport: false, // 显示批量导入
      openExportWay: false, // 显示导出方式
      exportWay: "1", // 导出方式
      selectRoleTitle: "", // 分配角色标题
      selectRoleUserId: "", // 选择分配角色时 操作的客户id
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        customerType: "2", // 客户类型 1 客户 2 供应商
        customerName: "", // 客户名称
        phoneNumber: "", // 手机号
        email: "", // 邮箱号
        status: "", // 状态
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      selection: [], // 选中的列表数据

      loading: false,
      total: 0,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        customerType: "2", // 客户类型 1 客户 2 供应商
        customerName: "", //客户名称
        idCard: "", // 身份证号
        address: "", // 家庭住址
        sex: "", // 性别
        avatarList: [],
        avatar: "",
        email: "", // 邮箱
        phoneNumber: "", // 手机号
        remark: "" // 备注
      }
    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          customerType: "2", // 客户类型 1 客户 2 供应商
          customerName: "", //客户名称
          idCard: "", // 身份证号
          address: "", // 家庭住址
          sex: "", // 性别
          avatarList: [],
          avatar: "",
          email: "", // 邮箱
          phoneNumber: "", // 手机号
          remark: "" // 备注
        }
        this.$refs.customerDialog && this.$refs.customerDialog.resetForm()
      }
    },
    // 监听show
    showImport(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.importDialog.reset()
        })
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 系统内设客户 禁止操作
    checkSelectable(row, index) {
      if (row.beUsedInInventoryRecord) {
        return false
      } else {
        return true
      }
    },
    //点击行
    clickRow(row) {
      if (row.beUsedInInventoryRecord) {
        return
      } 
      this.$refs.customerTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.customerId)
        str += item.customerName
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }

      this.$modal
        .confirm('是否确认删除姓名为"【' + str + '】"的数据项？')
        .then(function() {
          return customerApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除客户成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.customerTable.clearSelection()
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true
      customerApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.customerId) {
        this.isUpdate = true
      }
      const id = row.customerId || (this.selection[0] && this.selection[0].customerId)
      customerApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        if (this.baseForm.avatar) {
          this.baseForm.avatarList = [
            {
              name: "头像",
              url: this.baseForm.avatar
            }
          ]
        }
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const id = row.customerId
      this.$modal
        .confirm('是否确认删除姓名为"' + row.customerName + '"的数据项？')
        .then(function() {
          return customerApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.customerId === id)
          flag && this.$refs.customerTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    },
    // 状态改变事件
    handleStatusChange(row) {
      if (row.beUsedInInventoryRecord) {
        return
      } 
      // 让按钮返回原样
      this.mixinBtnBlur()

      customerApi
        .changeStatus({
          customerId: row.customerId,
          status: row.status === "1" ? "0" : "1"
        })
        .then((data) => {
          this.$modal.msgSuccess("改变状态成功")
          this.getList()
        })
    }
  }
}
</script>
